import React, { useCallback } from "react";

import AddIcon from "@mui/icons-material/Add";
import FormDialog from "../../../../components/Dialog/FormDialog";
import CreateTeamForm from "./CreateTeamForm";
import { useResponsive } from "../../../../hooks/useResponsive";
import { CustomButton } from "../../../../components/Button/Button";
import ManageTeams from "./ManageTeams";
import { Typography } from "@mui/material";

function CreateTeam() {
  const [openCreateTeamDialog, setOpenCreateTeamDialog] = React.useState(false);
  const [openManageTeamDialog, setOpenManageTeamDialog] = React.useState(false);
  const isMobile = useResponsive("down", "md");

  const handleCreateTeamClickOpen = useCallback(() => {
    setOpenCreateTeamDialog(true);
  }, []);

  const handleCreateTeamClose = useCallback(() => {
    setOpenCreateTeamDialog(false);
  }, []);

  const handleManageTeamClickOpen = useCallback(() => {
    setOpenManageTeamDialog(true);
  }, []);

  const handleManageTeamClose = useCallback(() => {
    setOpenManageTeamDialog(false);
  }, []);

  return (
    <div>
      {openCreateTeamDialog && (
        <FormDialog
          open={openCreateTeamDialog}
          handleClose={handleCreateTeamClose}
          title={"Create Team"}
          btnTitle={"Add"}
          fullWidth={true}>
          <CreateTeamForm onClose={handleCreateTeamClose} />
        </FormDialog>
      )}
      {openManageTeamDialog && (
        <FormDialog
          open={openManageTeamDialog}
          handleClose={handleManageTeamClose}
          title={"Manage Team"}
          btnTitle={"Add"}
          fullWidth={true}
          customHeaderComponent={<Typography onClick={handleCreateTeamClickOpen} className="create_team_link">Create Team</Typography>}>
          <ManageTeams onClose={handleManageTeamClose} />
        </FormDialog>
      )}
      <CustomButton
        onClick={handleManageTeamClickOpen}
        className="capitalize theme-bg-color create-team-button"
        variant="contained"
        startIcon={<AddIcon />}>
        Manage Team
      </CustomButton>
    </div>
  );
}

export default React.memo(CreateTeam);
